import type { CityConfig } from "../city-template/types";

export const hanoverConfig: CityConfig = {
  city: "Hanover",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "hanover",
  route: "/cities/hanover",
  title: "Emergency Passport Hanover, NH | Dartmouth & Upper Valley Expedited Services",
  metaDescription: "Emergency passport and expedited passport services in Hanover, NH — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Dartmouth College, Upper Valley, and Grafton County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Hanover, NH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Hanover, Dartmouth College, and Upper Valley travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Hanover%20New%20Hampshire%20Dartmouth%20College%20campus%20view%20with%20the%20iconic%20Baker%20Memorial%20Library%20clock%20tower%2C%20beautiful%20Ivy%20League%20college%20green%20with%20historic%20Georgian%20architecture%20buildings%2C%20the%20Connecticut%20River%20flowing%20nearby%2C%20autumn%20foliage%20with%20brilliant%20red%20and%20orange%20maple%20trees%2C%20warm%20golden%20afternoon%20light%2C%20academic%20and%20scholarly%20atmosphere%2C%20no%20visible%20text%20or%20people%2C%20photorealistic%20landscape%20with%20warm%20earth%20tones%20and%20green%20campus%20lawns%2C%20prestigious%20New%20England%20college%20town%20scene&width=1800&height=700&seq=hanover-nh-hero-001&orientation=landscape",
  heroImageAlt: "Hanover New Hampshire Dartmouth College campus with Baker Memorial Library and the Connecticut River",
  geoPosition: "43.7022;-72.2896",
  geoPlacename: "Hanover, New Hampshire",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Customs House St, Boston, MA 02103",
    distance: "Located in downtown Boston — approximately 2.5 to 3 hours from Hanover via I-91 and I-93",
  },
  nearbyCitiesZips: [
    { name: "Hanover", zips: "03755" },
    { name: "Lebanon", zips: "03766, 03784" },
    { name: "Norwich, VT", zips: "05055" },
    { name: "Hartford, VT", zips: "05047, 05001" },
    { name: "White River Junction, VT", zips: "05001" },
    { name: "Enfield", zips: "03748" },
    { name: "Lyme", zips: "03768" },
    { name: "Plainfield", zips: "03781" },
    { name: "Canaan", zips: "03741" },
    { name: "Dorchester", zips: "03266" },
    { name: "Grafton", zips: "03240" },
    { name: "Orford", zips: "03777" },
    { name: "Piermont", zips: "03779" },
    { name: "Rumney", zips: "03266" },
    { name: "Bath", zips: "03740" },
    { name: "Haverhill", zips: "03765" },
    { name: "Woodstock, VT", zips: "05091" },
    { name: "Quechee, VT", zips: "05059" },
    { name: "Pomfret, VT", zips: "05067" },
    { name: "Strafford, VT", zips: "05072" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Upper Valley and Dartmouth departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Lebanon", route: "/cities/lebanon" },
    { name: "Concord", route: "/cities/concord-nh" },
    { name: "Keene", route: "/cities/keene" },
    { name: "Manchester", route: "/cities/manchester" },
    { name: "Nashua", route: "/cities/nashua" },
    { name: "Portsmouth", route: "/cities/portsmouth" },
    { name: "Laconia", route: "/cities/laconia" },
    { name: "Dover", route: "/cities/dover" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Hanover and the Upper Valley remotely via secure courier. We do not have a walk-in office in Hanover — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Upper Valley travelers, regardless of the 2.5+ hour distance to Boston.",
  fpcOfficeDistance: "Serving all of Grafton County and the Upper Valley region",
  serviceAreaIntro: "From the Dartmouth College campus to the Hanover town center, from the Norwich, Vermont side of the Connecticut River to the rural Lyme hills — Fast Passport Center serves the entire Hanover community. We regularly help Dartmouth students, faculty, and Upper Valley residents from Lebanon, White River Junction, and Norwich get their passports fast.",
  nearbyCitiesIntro: "We serve all Hanover neighborhoods and nearby Upper Valley cities including Lebanon, Norwich VT, Hartford VT, White River Junction VT, Enfield, Lyme, Plainfield, Canaan, Grafton, Orford, Woodstock VT, and Quechee VT. If you are in the greater Upper Valley area, we have you covered.",
  howItWorksIntro: "Most Hanover travelers complete everything online and ship documents overnight. No need to drive 2.5+ hours to Boston or wait in line at the regional agency — our courier service handles the long drive for you.",
  mistakesIntro: "With Dartmouth College's international study programs, research conferences, and the Upper Valley's active global travel community, Hanover travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Hanover, Dartmouth, and Upper Valley travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Hanover? Here are the most common ones we hear from Dartmouth and Upper Valley travelers.",
  statePageRoute: "/states/new-hampshire",
  statePageName: "New Hampshire",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Hanover international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Dr. Elizabeth C.",
      location: "Hanover, NH",
      rating: 5,
      text: "As a Dartmouth professor heading to a conference in Berlin, I discovered my passport had expired. Fast Passport Center had it renewed in 48 hours. Saved my presentation and my reputation.",
      service: "Passport Renewal",
    },
    {
      name: "Michael T.",
      location: "Lebanon, NH",
      rating: 5,
      text: "The 2.5-hour drive to Boston is not something I have time for. Using Fast Passport Center meant I could ship from Lebanon and never leave the Upper Valley. Passport arrived in 3 days.",
      service: "Expedited Renewal",
    },
    {
      name: "Sarah L.",
      location: "Norwich, VT",
      rating: 5,
      text: "My daughter's study abroad program in Spain started in a week and her passport was missing. Fast Passport Center handled everything from across the river in Vermont. Incredible service.",
      service: "Lost Passport",
    },
    {
      name: "Dr. Robert K.",
      location: "Hanover, NH",
      rating: 5,
      text: "Dartmouth's international research partnerships require frequent travel. Fast Passport Center has been our lab's trusted partner for years. Reliable, fast, and they understand academic schedules.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "hanover-nh-1",
      name: "Hanover Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "69 S Main St",
      city: "Hanover",
      state: "NH",
      zip: "03755",
      phone: "(603) 643-2154",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.2 miles from Dartmouth Green",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Hanover and Dartmouth College. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "hanover-nh-2",
      name: "Lebanon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11 E Park St",
      city: "Lebanon",
      state: "NH",
      zip: "03766",
      phone: "(603) 448-3521",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles from Hanover",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Large facility with extended hours. Convenient for Upper Valley residents. Photo services available. Book appointments well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "hanover-nh-3",
      name: "White River Junction Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "50 S Main St",
      city: "White River Junction",
      state: "VT",
      zip: "05001",
      phone: "(802) 295-8521",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "6 miles from Hanover",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Vermont-side Upper Valley residents. Limited hours — book appointments early.",
      icon: "ri-mail-line",
    },
    {
      id: "hanover-nh-4",
      name: "Norwich Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "20 Church St",
      city: "Norwich",
      state: "VT",
      zip: "05055",
      phone: "(802) 649-1512",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "3 miles from Hanover",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Norwich and Vermont-side residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "hanover-nh-5",
      name: "Hanover Town Clerk",
      type: "Town Clerk Passport Acceptance",
      address: "41 S Main St",
      city: "Hanover",
      state: "NH",
      zip: "03755",
      phone: "(603) 643-0742",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.1 miles from Hanover town center",
      website: "https://www.hanovernh.org/",
      websiteLabel: "Hanover Town Clerk",
      notes: "Municipal facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
    {
      id: "hanover-nh-6",
      name: "Lebanon City Clerk",
      type: "City Clerk Passport Acceptance",
      address: "51 N Park St",
      city: "Lebanon",
      state: "NH",
      zip: "03766",
      phone: "(603) 448-3054",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "5 miles from Hanover",
      website: "https://www.lebanonnh.gov/",
      websiteLabel: "Lebanon City Clerk",
      notes: "Major municipal facility for Upper Valley residents. Accepts walk-ins but appointments recommended.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2.5+ hour drive to Boston", fpc: "No — ship from home or office in Hanover" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Hanover photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Grafton County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Hanover applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Hanover families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Hanover travelers often assume standard processing will be fine. It takes 6–13 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Hanover or Lebanon." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Hanover address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Hanover before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Hanover for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most Upper Valley travelers." },
    { q: "How fast can I renew my passport in Hanover?", a: "Fast Passport Center offers fast passport renewal in Hanover in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What if my passport expires before my Dartmouth study abroad program?", a: "If your passport expires before your Dartmouth study abroad program, contact Fast Passport Center immediately. We can expedite your passport renewal in Hanover in 24–48 hours so you don't miss your program departure. We regularly help Dartmouth students with study abroad passport needs." },
    { q: "Can I get a same-day passport appointment near Hanover?", a: "Same-day passport appointments are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Hanover residents — without the 2.5+ hour drive to Boston." },
    { q: "Can I expedite a child passport in Hanover?", a: "Yes. Fast Passport Center expedites child passports in Hanover for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Hanover with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Hanover?", a: "With Fast Passport Center's emergency courier service, Hanover travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays and the long drive to Boston." },
    { q: "Do I need to visit the Boston Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight from Hanover. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Hanover?", a: "Popular options include the Hanover Post Office (03755), Lebanon Post Office (03766), White River Junction Post Office (05001 VT), Norwich Post Office (05055 VT), and Hanover Town Clerk (03755). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Hanover?", a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option." },
    { q: "What if I live in Vermont near Hanover like Norwich or White River Junction?", a: "We serve the entire Upper Valley including Norwich VT, White River Junction VT, Hartford VT, Lebanon NH, Lyme NH, and Enfield NH. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Hanover?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Hanover", address: "73 S Main St, Hanover, NH 03755", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Lebanon", address: "5 E Park St, Lebanon, NH 03766", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Lebanon", address: "10 E Park St, Lebanon, NH 03766", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "UPS Store — Lebanon", address: "5 E Park St, Lebanon, NH 03766", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — West Lebanon", address: "1900 Main St, West Lebanon, NH 03784", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Hanover", address: "2 Allen St, Hanover, NH 03755", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Postal Annex — Hanover", address: "69 S Main St, Hanover, NH 03755", hours: "Mon–Fri: 9AM–6PM, Sat: 9AM–4PM" },
    { name: "Costco — West Lebanon", address: "1900 Main St, West Lebanon, NH 03784", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM" },
  ],
  dmvLocations: [
    { name: "DMV — Lebanon", address: "23 Spencer St, Lebanon, NH 03766", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID and driver's license renewals. Passport-ready photo services available. Online appointment booking.", featured: true },
    { name: "DMV — White River Junction, VT", address: "100 US-5, White River Junction, VT 05001", hours: "Mon–Fri: 8AM–5PM", note: "Passport-ready photo services available. Appointment required.", featured: false },
    { name: "DMV — Newport", address: "10 Main St, Newport, NH 03773", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID processing. Walk-ins limited — book online first.", featured: false },
    { name: "DMV — Claremont", address: "5 Main St, Claremont, NH 03743", hours: "Mon–Fri: 8AM–5PM", note: "Full-service center for western New Hampshire and Upper Valley residents.", featured: true },
  ],
  airports: [
    { code: "LEB", name: "Lebanon Municipal Airport", distance: "6 miles from Hanover", address: "5 Airport Rd, West Lebanon, NH 03784", note: "Regional commercial airport with Cape Air flights to Boston Logan. Convenient for Upper Valley travelers.", flightUrl: "https://www.lebanonairport.com/", flightLabel: "LEB Flight Info", featured: true },
    { code: "MHT", name: "Manchester-Boston Regional Airport", distance: "85 miles from Hanover", address: "1 Airport Rd, Manchester, NH 03103", note: "Major commercial airport accessible via I-91. International flights to Canada and Europe.", flightUrl: "https://www.flymanchester.com/", flightLabel: "MHT Flight Info", featured: false },
    { code: "BOS", name: "Boston Logan International Airport", distance: "130 miles from Hanover", address: "1 Harborside Dr, Boston, MA 02128", note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via I-91 and I-93.", flightUrl: "https://www.massport.com/logan-airport", flightLabel: "Logan Airport", featured: false },
  ],
};